import type { GlobalPresenceOption } from "../types";
import type { CommonLookupResponse } from "newui/store/tanstack-base";
import { useCommonLookup } from "newui/store/tanstack-base";
import { fetchGlobalPresence } from "../company-api";

export const useGlobalPresence = (): CommonLookupResponse<GlobalPresenceOption> =>
	useCommonLookup<GlobalPresenceOption>("globalPresence", fetchGlobalPresence);
